import { render, staticRenderFns } from "./ChallengeList.vue?vue&type=template&id=fb818b70&"
import script from "./ChallengeList.vue?vue&type=script&lang=js&"
export * from "./ChallengeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports